<div class="sa-flex-password-container">
  <div class="update-password">
    <div class="flex flex-row justify-center">
      <img width="80" src="../../assets/icons/sandi-lite.svg" />
    </div>
    <div class="flex flex-row justify-center mb-3">
      Last Mile Made Simple
    </div>
    <div class="back-wrap"><i class="material-icons">arrow_back</i><a (click)="logout()">Back to login</a></div>
    <div class="form-wrap">
      <form (ngSubmit)="updatePassword()" [formGroup]="updatePasswordForm">
        <h2>Update Password</h2>
        <div class="flex flex-col">
          <div class="formFieldLabel">
            New Password
          </div>
          <mat-form-field appearance="outline">
            <input
              type="password"
              matInput
              [formControl]="updatePasswordForm.controls['password']"
              [type]="hideNewPassword ? 'password' : 'text'"
            />
            <i class="material-icons" matSuffix (click)="hideNewPassword = !hideNewPassword">
              {{ hideNewPassword ? 'visibility' : 'visibility_off' }}
            </i>
            <mat-error *ngIf="updatePasswordForm.controls['password'].hasError('required')">
              Password is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col">
          <div class="formFieldLabel">
            Confirm Password
          </div>
          <mat-form-field appearance="outline">
            <input
              type="password"
              matInput
              [formControl]="updatePasswordForm.controls['confirmPassword']"
              [type]="hideConfirmPassword ? 'password' : 'text'"
            />
            <i class="material-icons" matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">
              {{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}
            </i>
            <mat-error
              *ngIf="
                updatePasswordForm.controls['confirmPassword'].hasError('diff') &&
                !updatePasswordForm.controls['confirmPassword'].hasError('required')
              "
            >
              Passwords do not match
            </mat-error>
          </mat-form-field>
        </div>
        <div class="button-wrap">
          <button mat-raised-button color="accent">Update Password</button>
        </div>
      </form>
    </div>
  </div>
</div>
